<template>
  <div>
    <v-dialog v-model="showchange" width="800">
      <template #activator="{ on }">
        <v-btn
          v-if="!$store.state.isFacebook"
          flat
          outline
          class="primary mr-2 hidden-xs-only"
          :style="`line-height: 10px;color: white;border-color: white !important;`"
          v-on="on"
          >{{ $t('change password') }}</v-btn
        >
        <v-btn
          v-if="!$store.state.isFacebook"
          fab
          small
          outline
          class="primary mr-2 hidden-sm-and-up"
          :style="`line-height: 10px;color: ${$vuetify.theme.primary};`"
          v-on="on"
        >
          <v-icon small>vpn_key</v-icon></v-btn
        >
      </template>
      <v-card v-if="showchange">
        <v-container>
          <v-card-text>
            <h1>{{ $t('Change Password') }}</h1>
            <form class="form-control" :class="{ 'has-error': errors.has('password') }">
              <label>{{ $t('New password') }}</label>
              <input
                ref="password"
                v-model.trim="password"
                v-validate="'required|isValidPassword'"
                name="password"
                type="password"
                :data-vv-as="$t('password')"
                autocomplete="on"
              />
              <span v-if="errors.has('password')" class="text-error">{{
                errors.first('password')
              }}</span>
            </form>
            <PasswordValidation
              v-show="!isValidPassword"
              :value="password"
              :is-valid.sync="isValidPassword"
              class="mt-3"
            />
            <form
              class="form-control"
              :class="{ 'has-error': errors.has('passwordconfirm'), 'mt-3': true }"
            >
              <label>{{ $t('Confirm password') }}</label>
              <input
                v-model.trim="confirmpassword"
                v-validate="'required|confirmed:password'"
                name="passwordconfirm"
                :data-vv-as="$t('password')"
                type="password"
                autocomplete="on"
              />
              <span v-if="errors.has('passwordconfirm')" class="text-error">{{
                errors.first('passwordconfirm')
              }}</span>
            </form>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="cancel">{{ $t('cancel') }}</v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                @click="changepassword"
                >{{ $t('Save') }}</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import PasswordValidation from '@/components/elements/PasswordValidation'

export default {
  components: {
    PasswordValidation
  },
  data() {
    return {
      showchange: false,
      loading: false,
      password: '',
      confirmpassword: '',
      isValidPassword: false
    }
  },
  computed: {
    ...mapGetters(['isFacebook', 'currentLang'])
  },
  methods: {
    cancel() {
      //   this.password = ''
      //   this.confirmpassword = ''
      this.showchange = false
    },
    changepassword() {
      var vm = this
      var data = { password: this.confirmpassword }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          return false
        }

        this.loading = true

        api.changepasswordadminuser(data, (error, response) => {
          if (error) console.error(error)
          this.loading = false
          if (response.responsecode == 200) {
            vm.$swal
              .fire({
                type: 'success',
                title: vm.$t('Success')
              })
              .then(() => {
                vm.$store.dispatch('logout', null).then()
                if (vm.isFacebook) {
                  vm.$router.push('/' + vm.currentLang + '/login')
                } else {
                  vm.$router.push('/' + vm.currentLang + '/nigol')
                }
              })
          }
        })
      })
    }
  }
}

// onChangePassword() {
//   let vm = this
//   vm.$validator.validate().then(result => {
//     if (!result) {
//       // do stuff if not valid.
//       return false
//     }
//     let obj = {
//       adminid: vm.$store.state.userid,
//       password: vm.input.password
//     }
//     api.changepasswordadminuser({ obj }, (err, response) => {
//       if (err) console.error(err)
//       var isFacebook = vm.isFacebook
//       vm.$store.dispatch('logout', null).then()
//       if (isFacebook) {
//         vm.$router.push('/' + vm.currentLang + '/login')
//       } else {
//         vm.$router.push('/' + vm.currentLang + '/nigol')
//       }
//     })
//   })
// },
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/ChangePassword.vue